import { render } from "./PageSavingUp.vue?vue&type=template&id=069a02f2"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PageSavingUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "069a02f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('069a02f2', __exports__)) {
    api.reload('069a02f2', __exports__)
  }
  
  module.hot.accept("./PageSavingUp.vue?vue&type=template&id=069a02f2", () => {
    api.rerender('069a02f2', render)
  })

}


export default __exports__